import { Component, Shark } from "shark-mvc";

import templateContent from "./province-filter.html";

class ProvinceFilterComponent extends Component {
	constructor () {
		super("provinceFilterComponent");

		this.addTemplate("", templateContent);

		this.behavior = "live";
	}

	beforeLoad () {
		if (!this.$store.preserveFilterStatus) {
			this.set({
				__provinceFilterStatusCSSClass: "",
			});

			const provinceFilter = Shark.get("provinceFilter");
			provinceFilter.province = "all";
		}
	}
	
	beforeUnload () {
		if (!this.$store.preserveFilterStatus) {
			this.set({
				__provinceFilterStatusCSSClass: "",
			});

			const provinceFilter = Shark.get("provinceFilter");
			provinceFilter.province = "all";
		}
	}
	
	init () {
		const provinceFilter = Shark.getInstance("__smart__", {
			province: "all"
		});
	
		provinceFilter.on("dataChanged", function () {
			provinceFilterComponent.set({
				__provinceFilterStatusCSSClass: this.province !== "all" ? "bg-warning" : "",
			});

			if (this.behavior !== "live" && typeof Shark.activePage.refreshList === "function") {
				Shark.activePage.refreshList(null, true);
			}
			else {
				Shark.render();
			}
		});
	
		this.set({
			preserveFilterStatus: false,
			__provinceFilterStatusCSSClass: "",
			__preserveProvinceFilterStatusCSSClass: "btn-outline-primary",
		});

		Shark.set({provinceFilter});
	}

	preserveProvinceFilterStatusBtn_clickHandler () {
		this.togglePreserveProvinceFilterStatus();
	}

	togglePreserveProvinceFilterStatus () {
		const preserveFilterStatus = !this.$store.preserveFilterStatus;

		this.set({
			preserveFilterStatus,
			__preserveProvinceFilterStatusCSSClass: preserveFilterStatus ? "btn-primary" : "btn-outline-primary",
		});
		Shark.render();
	}
}

const provinceFilterComponent = new ProvinceFilterComponent();

Shark.registerComponent(provinceFilterComponent);

export default provinceFilterComponent;
